/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// eslint-disable-next-line object-curly-newline
import { Grid, Container, Typography, Box, Button } from '@material-ui/core';
import updateState from '../../actions/updateState';
import translate from '../../actions/translate';
import MenuPreviewDialog from './MenuPreviewDialog';
import updateAnalytics from '../../actions/updateAnalytics';
import DesignAndLanguages from '../../components/DesignAndLanguages';
import LogoAndStepper from '../../components/LogoAndStepper';
import TopLayer from '../../components/layers/TopLayer';
import MiddleLayer from '../../components/layers/MiddleLayer';
import BottomLayer from '../../components/layers/BottomLayer';
import ViewPortContainer from '../../components/layers/ViewPortContainer';
import TransitionButtons from '../../components/TransitionButtons';
import BoxContentContainer from '../../components/layers/BoxContentContainer';
// import Steppers from './Stepper';

export default function SeamlessForm() {
  // media query, on greater than iphone
  const dispatch = useDispatch();
  const language = useSelector((state) => state.formState.Page_language);
  const source = useSelector((state) => state.formState.Signup_type);
  const restaurantId = useSelector((state) => state.formState.Restaurant_id);
  const facebook = useSelector((state) => state.formState.facebook);

  useEffect(() => {
    if (facebook) {
      updateAnalytics(
        {
          facebook,
        },
        restaurantId
      );
    }
    updateAnalytics(
      {
        language,
      },
      restaurantId
    );
    updateAnalytics(
      {
        source,
      },
      restaurantId
    );
    updateAnalytics(
      {
        id: restaurantId,
      },
      restaurantId
    );
    updateAnalytics(
      {
        formStarted: true,
      },
      restaurantId
    );
  }, [language, restaurantId]);
  return (
    <ViewPortContainer>
      <TopLayer>
        <LogoAndStepper step={1} showStepper />
      </TopLayer>{' '}
      <MiddleLayer>
        <BoxContentContainer>
          <Typography variant="h4">
            {translate('Preview Customer Experience')}
          </Typography>

          <br />

          <Typography variant="h6">
            {translate(
              'For now, we’ll use a sample menu to get started. Click to open it! This is what the customer sees.'
            )}
          </Typography>
          <br />

          <Grid justify="center" item container>
            <MenuPreviewDialog />
          </Grid>
          <br />
          <br />

          <TransitionButtons showBack />
        </BoxContentContainer>{' '}
      </MiddleLayer>
      <BottomLayer>
        <DesignAndLanguages />
      </BottomLayer>{' '}
    </ViewPortContainer>
  );
}
